/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Pricing_Platinum_DescriptionInputs */

const en_pricing_platinum_description = /** @type {(inputs: Pricing_Platinum_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ultimate scaling for high-volume teams and businesses. ${i?.fee}% platform fee.`)
};

const es_pricing_platinum_description = /** @type {(inputs: Pricing_Platinum_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Escalabilidad definitiva para equipos y empresas de alto volumen. ${i?.fee}% de tarifa de plataforma.`)
};

const fr_pricing_platinum_description = /** @type {(inputs: Pricing_Platinum_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Évolution ultime pour les équipes et les entreprises à fort volume. ${i?.fee} % de frais de plateforme.`)
};

const de_pricing_platinum_description = /** @type {(inputs: Pricing_Platinum_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ultimative Skalierung für High-Volume-Teams und Unternehmen. ${i?.fee}% Plattformgebühr.`)
};

const id_pricing_platinum_description = /** @type {(inputs: Pricing_Platinum_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Skala ultimate untuk tim dan bisnis bervolume tinggi. Biaya platform ${i?.fee}%.`)
};

/** @type {(inputs: Pricing_Platinum_DescriptionInputs) => LocalizedString} */
const ja_pricing_platinum_description = en_pricing_platinum_description;

/** @type {(inputs: Pricing_Platinum_DescriptionInputs) => LocalizedString} */
const zh_pricing_platinum_description = en_pricing_platinum_description;

/** @type {(inputs: Pricing_Platinum_DescriptionInputs) => LocalizedString} */
const ar_pricing_platinum_description = en_pricing_platinum_description;

/** @type {(inputs: Pricing_Platinum_DescriptionInputs) => LocalizedString} */
const it_pricing_platinum_description = en_pricing_platinum_description;

/** @type {(inputs: Pricing_Platinum_DescriptionInputs) => LocalizedString} */
const ru_pricing_platinum_description = en_pricing_platinum_description;

/** @type {(inputs: Pricing_Platinum_DescriptionInputs) => LocalizedString} */
const pt_pricing_platinum_description = en_pricing_platinum_description;

/** @type {(inputs: Pricing_Platinum_DescriptionInputs) => LocalizedString} */
const ko_pricing_platinum_description = en_pricing_platinum_description;

/**
* | output |
* | --- |
* | "Ultimate scaling for high-volume teams and businesses. {fee}% platform fee." |
*
* @param {Pricing_Platinum_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_platinum_description = /** @type {((inputs: Pricing_Platinum_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Platinum_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_platinum_description(inputs)
	if (locale === "es") return es_pricing_platinum_description(inputs)
	if (locale === "fr") return fr_pricing_platinum_description(inputs)
	if (locale === "de") return de_pricing_platinum_description(inputs)
	if (locale === "ja") return ja_pricing_platinum_description(inputs)
	if (locale === "zh") return zh_pricing_platinum_description(inputs)
	if (locale === "ar") return ar_pricing_platinum_description(inputs)
	if (locale === "id") return id_pricing_platinum_description(inputs)
	if (locale === "it") return it_pricing_platinum_description(inputs)
	if (locale === "ru") return ru_pricing_platinum_description(inputs)
	if (locale === "pt") return pt_pricing_platinum_description(inputs)
	return ko_pricing_platinum_description(inputs)
});